import { Component, Input } from '@angular/core';

import { MessageService, notCloseMessageOptions } from '../../../../../core';
import { ClienteUnidadeNegocioSearchItemTipo } from './cliente-unidade-negocio-search-item-tipo';
import { ItemTipo } from '../../../../item-tipo';

@Component({
    selector: 'sgt-cliente-unidade-negocio-item-tipo',
    templateUrl: './cliente-unidade-negocio-item-tipo.component.html',
    styleUrls: ['./cliente-unidade-negocio-item-tipo.component.less']
})
export class ClienteUnidadeNegocioItemTipoComponent {
    @Input() canEdit = true;
    /** ID do cliente */
    @Input() idCliente: number;

    /** ID da unidade de negócio */
    @Input() idUnidadeNegocio: number;
    /** Nome da unidade de negócio */
    @Input() nomeUnidadeNegocio: string;
    /** Index da unidade de negócio */
    @Input() indexUnidadeNegocio: number;

    /** ID do mercado */
    @Input() idMercado: number;
    /** Nome do mercado */
    @Input() nomeMercado: string;
    /** Index do mercado */
    @Input() indexMercado: number;

    /** ID da natureza de venda */
    @Input() idNaturezaVenda: number;
    /** Nome da natureza de venda */
    @Input() nomeNaturezaVenda: string;
    /** Index da natureza de venda */
    @Input() indexNaturezaVenda: number;

    /** Tipos de itens cadastrados no cliente */
    @Input() itensTipos: ItemTipo[] = [];

    /** Tipos de itens */
    @Input() entities: ClienteUnidadeNegocioSearchItemTipo[] = [];

    constructor(private messageService: MessageService) { }

    insert() {
        if (!this.canEdit) {
            return;
        }
        const entity = new ClienteUnidadeNegocioSearchItemTipo();
        this.entities.push(entity);
    }

    delete(index: number) {
        if (index < 0 || !this.canEdit) {
            return;
        }

        const entity = this.entities[index];
        this.messageService.confirm(`Deseja realmente remover o tipo de produto ${entity?.nomeItemTipo ?? ''} da unidade de negócio ${this.nomeUnidadeNegocio ?? ''}, mercado ${this.nomeMercado ?? ''} e natureza de venda ${this.nomeNaturezaVenda ?? ''}?`, 'Confirme').then(result => {
            if (result) {
                this.entities.splice(index, 1);
            }
        });
    }

    /** Ao selecionar o tipo de item */
    onSelectItemTipo(entity: ClienteUnidadeNegocioSearchItemTipo, idItemTipo: number) {
        if (idItemTipo) {
            entity.idItemTipo = idItemTipo;

            const itemTipo = this.itensTipos?.find(itemTipoFilter => itemTipoFilter.id === idItemTipo);
            entity.nomeItemTipo = itemTipo?.nome ?? null;
        } else {
            entity.idItemTipo = null;
            entity.nomeItemTipo = null;
        }
    }

    /** Verifica os tipos de item estão válidos */
    isValid(): boolean {
        if (!this.canEdit) {
            return true;
        }

        for (let i = 0; i < this.entities.length; i++) {
            const entity = this.entities[i];
            if (!entity.idItemTipo) {
                continue;
            }

            const count = this.entities.filter(entityFilter => entityFilter.idItemTipo && entityFilter.idItemTipo === entity.idItemTipo).length;
            if (count > 1) {
                this.messageService.warning(`O tipo de produto ${entity.nomeItemTipo ?? ''} já está adicionado na unidade de negócio ${this.nomeUnidadeNegocio ?? ''}, mercado ${this.nomeMercado ?? ''} e natureza de venda ${this.nomeNaturezaVenda ?? ''}. Remova ou altere o tipo de produto duplicado`, 'Não é possível adicionar dois tipos de produtos iguais na mesma unidade de negócio, mercado e natureza de venda', notCloseMessageOptions);
                return false;
            }
        }
        return true;
    }
}
